/** @format */
import { CourseUnitEnrolmentRight, CourseUnitSubstitutionRight, EnrolmentRight } from 'common-typescript/types';

export function isCourseUnitEnrolmentRight(enrolmentRight: EnrolmentRight): enrolmentRight is CourseUnitEnrolmentRight {
    return enrolmentRight?.type === 'CUR_ENROLMENT';
}

export function isSubstitutionRight(enrolmentRight: EnrolmentRight): enrolmentRight is CourseUnitSubstitutionRight {
    return enrolmentRight?.type === 'SUBSTITUTION';
}
